<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex xs12 sm6 md4 v-for="(fnc, key) in functions" :key="key">
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{ fnc.name }}</h3>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat color="orange" @click="$router.push(fnc.link)">
              Use this tool
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import v from 'voca'
import functions from '../functions'

export default {
  data: () => ({
    functions
  })
}
</script>
